import { axiosInstance } from "../../utility/apiInstance";
import { TrackingDelays } from "./trackingThreshold.types";

const BASE = "/api/v1/tracking-threshold";

export const fetchTrackingThreshold = (organizationId: string) =>
    axiosInstance.get(`${BASE}/${organizationId}`);

export const saveTrackingThreshold = (organizationId: string, delays: TrackingDelays) =>
    axiosInstance.put(`${BASE}/${organizationId}`, { delays });

export const resetTrackingThresholdApi = (organizationId: string) =>
    axiosInstance.delete(`${BASE}/${organizationId}`);

export const fetchTrackingThresholdLogs = (organizationId: string, page = 0, pageSize = 20) =>
    axiosInstance.get(`${BASE}/${organizationId}/logs?page=${page}&pageSize=${pageSize}`);